import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { Notification, NotificationPayload } from '@local/client-contracts';
import { PopupRef } from '@local/ui-infra';
import { TimerService } from '@shared/services/timer.service';
import { animation } from './animation';

export const DEFAULT_NOTIFICATION_TIMEOUT = 5000;

@Component({
  selector: 'notification-popup',
  templateUrl: './notification-popup.component.html',
  styleUrls: ['./notification-popup.component.scss'],
  animations: [animation],
})
export class NotificationPopupComponent implements OnInit {
  /** May be also injected trough the ref */
  @Input() model: Notification;

  @Output() click = new EventEmitter<Notification>();
  @Output() close = new EventEmitter<boolean>();

  isSideEffect = false;

  constructor(private ref: PopupRef<NotificationPopupComponent, NotificationPayload>, private timerService: TimerService) {}

  private timeoutId: number;

  ngOnInit() {
    const { notification } = this.ref.data;
    this.model = notification;
    if (!this.model.requireInteraction) {
      this.startTimeout();
    }
  }

  @HostListener('click', ['$event']) onClick(event: MouseEvent) {
    this.isSideEffect = true;
    if (event.composedPath().some((t) => t instanceof HTMLElement && t.id === 'notification-close')) return;
    event.stopPropagation();
    event.preventDefault();
    this.click.emit();
  }

  @HostListener('mouseover')
  onMouseOver() {
    this.isSideEffect = true;
    this.stopTimeout();
  }

  @HostListener('mouseout')
  onMouseOut() {
    if (!this.model.requireInteraction) {
      this.startTimeout();
    }
  }

  private startTimeout() {
    this.timeoutId = this.timerService.register(() => this.ref && this.close.emit(this.isSideEffect), {
      visibleInterval: DEFAULT_NOTIFICATION_TIMEOUT,
      focusInterval: DEFAULT_NOTIFICATION_TIMEOUT,
    });
  }

  private stopTimeout() {
    if (this.timeoutId) {
      this.timerService.unregister(this.timeoutId);
    }
  }
}
